import React from "react";
import { Flex, Form, Typography } from "antd";
import { useTranslate } from "@refinedev/core";
import { Toggle } from "@libertify/ui";

interface ChatbotSettingRowProps {
  /** Form path, from `ChatbotSettingsFields`' `FIELD`. */
  name: string[];
  /** Key under `createExperience.addOns.aiChat` holding `label` and
   *  `description`. */
  tKey: string;
}

/** One chat setting on the edit page: name and explanation left, switch
 *  right. */
export const ChatbotSettingRow: React.FC<ChatbotSettingRowProps> = ({
  name,
  tKey,
}) => {
  const t = useTranslate();
  const label = t(`createExperience.addOns.aiChat.${tKey}.label`);

  return (
    <Flex align="center" gap={24} justify="space-between">
      <Flex vertical gap={2} style={{ minWidth: 0 }}>
        <Typography.Text strong>{label}</Typography.Text>
        <Typography.Text type="secondary">
          {t(`createExperience.addOns.aiChat.${tKey}.description`)}
        </Typography.Text>
      </Flex>
      <Form.Item name={name} valuePropName="checked" noStyle>
        <Toggle size="l" aria-label={label} />
      </Form.Item>
    </Flex>
  );
};
